































































































import { defineComponent } from "vue";
import RefundInvoiceAdviserDigital from "../RefundInvoiceAdviserDigital.vue";
import RefundAttentionAdviser from "../RefundAttentionAdviser.vue";
import IconRow from "@/components/Atoms/icon-row.vue";

export default defineComponent({
  components: {
    RefundInvoiceAdviserDigital,
    RefundAttentionAdviser,
    IconRow
  }
});
